export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_06_blank.78f55e93.png";